export default {
  name: 'fourth',
  data: function() {
    return {}
  },
  props: ['high_consuming', 'landingText'],
  methods: {
    goToFifth: function() {
      this.$emit('change-component', 'fifth-component', this.high_consuming)
    },
    setNone: function() {
      this.high_consuming.swimming_pools = false
      this.high_consuming.time_based_garden_sprinklers = false
      this.high_consuming.showers_w_high_water_consumption = false
      this.high_consuming.other_devices_w_high_water_consumption = false
    },
    unSetNone: function() {
      this.high_consuming.none = false
    }
  },
  beforeMount: function() {

  }
}


// WEBPACK FOOTER //
// ./src/components/plan/subComponents/fourth/fourth.js